import i18next from '@/translation/i18n';

// 우선순위 코드
export enum PriorityCode {
    HIGHEST = 'HIGHEST',
    HIGH = 'HIGH',
    MEDIUM = 'MEDIUM',
    LOW = 'LOW',
    LOWEST = 'LOWEST',
}

export const PriorityCodeLabel: Record<PriorityCode, string> = {
    [PriorityCode.HIGHEST]: i18next.t('field.priority.highest'),
    [PriorityCode.HIGH]: i18next.t('field.priority.high'),
    [PriorityCode.MEDIUM]: i18next.t('field.priority.medium'),
    [PriorityCode.LOW]: i18next.t('field.priority.low'),
    [PriorityCode.LOWEST]: i18next.t('field.priority.lowest'),
};
